import { Users, Star } from 'lucide-react';

type Props = { weitereOffene: number; bestellungen12Monate: number };

const STAMMKUNDE_SCHWELLE = 5;

export function KundenkontextBadge({ weitereOffene, bestellungen12Monate }: Props) {
  if (weitereOffene === 0 && bestellungen12Monate < STAMMKUNDE_SCHWELLE) {
    return null;
  }
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-ink-soft">
      {weitereOffene > 0 && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-cream-warm px-2 py-0.5">
          <Users className="h-3 w-3" />
          {weitereOffene === 1
            ? '1 weitere offene Bestellung'
            : `${weitereOffene} weitere offene Bestellungen`}
        </span>
      )}
      {bestellungen12Monate >= STAMMKUNDE_SCHWELLE && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-gold-soft px-2 py-0.5 text-gold-dark">
          <Star className="h-3 w-3" />
          Stammkunde · {bestellungen12Monate} Bestellungen / 12 Monate
        </span>
      )}
    </div>
  );
}
